/**
 * Piezas de presentación compartidas por las guías de Conceptos de Nómina
 * (GuiaFormulas y GuiaConceptosLey).
 *
 * Viven aquí para que las dos guías se vean igual y copien al portapapeles igual.
 * Son sólo presentación: no traen datos ni lógica de negocio.
 */
import React from "react";
import { Tag, message } from "antd";

export const MONO = { fontFamily: "monospace" };

export const estiloCodigo = {
    ...MONO,
    display: "block",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    background: "#fafafa",
    border: "1px solid #f0f0f0",
    borderRadius: 4,
    padding: "6px 8px",
    fontSize: 12,
    cursor: "pointer",
};

export const copiar = (texto) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(
            () => message.success("Copiado"),
            () => message.info(texto)
        );
    } else {
        message.info(texto);
    }
};

// Nombre de variable en monoespaciado. Al dar clic se copia al portapapeles.
export const Nombre = ({ children }) => (
    <Tag
        style={{ ...MONO, cursor: "pointer", marginBottom: 2 }}
        onClick={() => copiar(children)}
        title="Clic para copiar"
    >
        {children}
    </Tag>
);

export const Codigo = ({ children }) => (
    <code style={estiloCodigo} onClick={() => copiar(children)} title="Clic para copiar">
        {children}
    </code>
);

export const Renglon = ({ nombre, desc }) => (
    <div style={{ marginBottom: 10, lineHeight: 1.5 }}>
        <Nombre>{nombre}</Nombre>
        <div style={{ fontSize: 12, color: "rgba(0,0,0,0.65)" }}>{desc}</div>
    </div>
);

// Ancho de los dos Drawers de ayuda, para que se abran igual desde el listado y
// desde el modal del concepto.
export const anchoDrawerGuia = () =>
    typeof window !== "undefined" ? Math.min(window.innerWidth - 32, 820) : 820;

// Por encima del ModalItem del concepto, para poder consultar sin cerrar lo capturado.
export const Z_INDEX_GUIA = 1300;
